import { isDefined } from "@clipboard-health/util-ts";
import { type UseQueryResult } from "@tanstack/react-query";

import { CbhSpecialistType } from "../constants";
import { type AccountManagerResponse, type BillingSpecialistResponse } from "./types";
import { useGetAccountManager } from "./useGetAccountManager";
import { useGetBillingSpecialist } from "./useGetFacilityBillingSpecialist";

export interface GetCBHSpecialistParams {
  facilityId?: string;
  type: CbhSpecialistType;
}

export type CBHSpecialistResponse = AccountManagerResponse | BillingSpecialistResponse;

export function useGetCBHSpecialist(
  params: GetCBHSpecialistParams
): UseQueryResult<CBHSpecialistResponse> {
  const { facilityId, type } = params;

  const accountManagerQuery = useGetAccountManager(
    { facilityId },
    {
      enabled: type === CbhSpecialistType.ACCOUNT_MANAGER && isDefined(facilityId),
    }
  );

  const billingSpecialistQuery = useGetBillingSpecialist(
    { facilityId },
    {
      enabled: type === CbhSpecialistType.BILLING_SPECIALIST && isDefined(facilityId),
    }
  );

  return type === CbhSpecialistType.ACCOUNT_MANAGER ? accountManagerQuery : billingSpecialistQuery;
}
